import React from 'react';
import StudentTable from './StudentTable';
import StudentDetails from './StudentDetails';

const AdminDashboard = ({
  studentInfoAdminDict,
  studentSessionsDict,
  studentSearch,
  setStudentSearch,
  completedModuleFilters,
  setCompletedModuleFilters,
  showDropdown,
  setShowDropdown,
  dropdownRef,
  sortConfig,
  handleStudentSelection,
  selectedStudent,
  setSelectedStudent,
  handleSort,
  expandedSessions,
  toggleSession,
  onDownloadCSV,
  getFilteredAndSortedStudents
}) => {
  return (
    <div className="admin-view">
      <h2 style={{ color: "#405159" }}>Admin Dashboard</h2>

      {/* All students module summary table */}
      <StudentTable
        studentInfoAdminDict={studentInfoAdminDict}
        studentSearch={studentSearch}
        setStudentSearch={setStudentSearch}
        completedModuleFilters={completedModuleFilters}
        setCompletedModuleFilters={setCompletedModuleFilters}
        showDropdown={showDropdown}
        setShowDropdown={setShowDropdown}
        dropdownRef={dropdownRef}
        sortConfig={sortConfig}
        handleStudentSelection={handleStudentSelection}
        handleSort={handleSort}
        setSelectedStudent={setSelectedStudent}
        onDownloadCSV={onDownloadCSV}
        getFilteredAndSortedStudents={getFilteredAndSortedStudents}
      />

      {selectedStudent && (
        <StudentDetails
          student={studentInfoAdminDict[selectedStudent]}
          sessions={studentSessionsDict}
          expandedSessions={expandedSessions}
          toggleSession={toggleSession}
        />
      )}
    </div>
  );
};

export default AdminDashboard;
